import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Cliente } from "../../../../services/Cliente";
import { IClienteForm } from "../../../../types/cliente";

export const useCadastrarCliente = () => {
  return useMutation({
    mutationFn: (data: IClienteForm) => Cliente.post(data),
    onError: ({
      response: {
        data: { mensagem },
      },
    }: any) => {
      toast.error(mensagem);
    },
  });
};
